
<template>
  <div :class="['h-min-content mx-auto mb-4', isCustomer ? 'w-2/4' : 'w-3/4']">
    <div class="p-8 bg-white rounded-2xl shadow-lg mx-4">
      <h2 class="text-center text-2xl text-blue-dark py-2"><b>Su inconformidad contra un emisor de valores fue registrada</b></h2>
      <p class="text-center text-sm text-gray-700">El código asignado es:</p>
      <h2 class="text-center text-4xl text-blue-dark py-6"><b>{{complaintCode}}</b></h2>
      <BaseButton type="button" @click.native="backToStart()" class="mx-auto w-1/2" label="VOLVER" />
    </div>
  </div>
</template>

<script>

export default {
  props: ['complaintCode','isCustomer'],
  methods: {
    backToStart() {       
      if(this.isCustomer){
        this.$router.push('/customer');
        return;
      }
      else{
        this.$router.push('/dashboard/complaints-emisor/confirm');
        return;
      }
    }
  }
}
</script>